import axios from "axios"

export const logout = async () => {
  await axios.post(`/logout`)
  // no return data is expected
}
